import { render, staticRenderFns } from "./CcIcon.ts.vue?vue&type=template&id=227c3f16"
import script from "./CcIcon.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CcIcon.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CcIcon.ts.vue?vue&type=style&index=0&id=227c3f16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports